import React, { useState, useEffect } from 'react';
import { cancelOrder } from '../services/api';
import './CancelOrderModal.css';

const CancelOrderModal = ({ isOpen, onClose, order, user, onSuccess }) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (order) {
            setReason('');
            setError('');
            setSuccess('');
        }
    }, [order, isOpen]);

    if (!isOpen || !order) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!reason.trim()) {
            setError('Please provide a cancellation reason.');
            return;
        }

        setError('');
        setLoading(true);

        try {
            const response = await cancelOrder({
                buyerId: user.buyerId,
                rowIndex: order.rowIndex,
                reason: reason.trim(),
            });

            if (response.success) {
                setSuccess('Order cancelled successfully!');
                setTimeout(() => {
                    onSuccess();
                }, 1500);
            } else {
                setError(response.message || 'Failed to cancel order');
            }
        } catch (err) {
            console.error(err);
            setError('An unexpected error occurred: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Order Cancellation</h2>
                    <button className="modal-close" onClick={onClose}><i className="ri-close-line"></i></button>
                </div>

                <div className="modal-body">
                    {success ? (
                        <div className="success-state-container">
                            <div className="success-icon-wrap">
                                <i className="ri-check-line"></i>
                            </div>
                            <h2 className="success-title">CANCELLATION SUCCESSFUL</h2>
                            <p className="success-subtitle">This window will close automatically...</p>
                        </div>
                    ) : (
                        <form id="cancel-order-form" onSubmit={handleSubmit} className="update-form">

                            <div className="warning-container" style={{ marginBottom: '2rem' }}>
                                <div className="note-box">
                                    <p><strong>NOTE:</strong> ONCE MARKED CANCELLED NO REFUND WILL BE DONE FROM OUR END.</p>
                                </div>
                            </div>

                            {error && <div className="error-message">{error}</div>}

                            <div className="order-info-section" style={{ marginBottom: '1rem' }}>
                                <div className="info-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
                                    <div className="info-item">
                                        <span className="info-label">Order ID:</span>
                                        <span className="info-value">{order.orderId}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="info-label">Product:</span>
                                        <span className="info-value">{order.brandName} - {order.productName}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="reason">Cancellation Reason <span style={{ color: '#ef4444' }}>*</span></label>
                                <textarea
                                    id="reason"
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                    required
                                    placeholder="Please explain why you are cancelling this order..."
                                    rows="4"
                                    className="form-textarea"
                                ></textarea>
                            </div>
                        </form>
                    )}
                </div>

                {!success && (
                    <div className="modal-actions">
                        <button 
                            type="submit" 
                            form="cancel-order-form" 
                            className="btn-submit btn-danger" 
                            disabled={loading}
                        >
                            {loading ? 'CANCELLING...' : 'CONFIRM CANCELLATION'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CancelOrderModal;
